import { render, staticRenderFns } from "./SuratRujukannonBPJSBody.vue?vue&type=template&id=f87e55d8&"
import script from "./SuratRujukannonBPJSBody.vue?vue&type=script&lang=js&"
export * from "./SuratRujukannonBPJSBody.vue?vue&type=script&lang=js&"
import style0 from "./SuratRujukannonBPJSBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports